export function getLoginTrackingRoute(redirect?: string) {
  const routeUrl = redirect || window.location.href

  try {
    return {
      route_host: new URL(routeUrl, window.location.origin).host,
      route_url: routeUrl,
    }
  }
  catch {
    return {
      route_host: window.location.host,
      route_url: window.location.href,
    }
  }
}
